// extracted by css-extract-rspack-plugin
export default {"root":"nBn85b","type":"oAsGXW"};